import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import DocumentSigner from 'packages/react-document-signer/DocumentSigner';
import UsaOnly from 'common/components/UsaOnly';

const styles = theme => ({
  root: {
    display: 'grid',
    gridTemplateColumns: ' 100%',
    gridTemplateRows: ' 100%',
    padding: ' 25px',
    boxSizing: ' border-box',
    width: ' 100%',
    height: ' calc(100% - 130px)',
  },
});

const DesktopDocumentSigner = props => {
  const {
    actions,
    actor,
    classes,
    documents,
    getDocumentImageUrls,
    me,
    templatesAcknowledgeNotes,
    templatesAcknowledgeTitle,
    throwFatalError,
  } = props;

  return (
    <div className={classes.root}>
      <Paper>
        <UsaOnly>
          {isUsa => (
            <DocumentSigner
              documents={documents}
              actor={actor}
              getDocumentImageUrls={getDocumentImageUrls}
              throwFatalError={throwFatalError}
              actions={actions}
              templatesAcknowledgeNotes={templatesAcknowledgeNotes}
              templatesAcknowledgeTitle={templatesAcknowledgeTitle}
              me={me}
              isSaveSignatureEnabled
              showI9Note={isUsa}
            />
          )}
        </UsaOnly>
      </Paper>
    </div>
  );
};

export default withStyles(styles)(DesktopDocumentSigner);
